module.exports = __webpack_public_path__ + "img/RX-RAD-CONVENCIONAL-Moviles-6.9106bf82.png";